import { useReducer } from 'react';
import { FormTwoReducer } from './FormTwoReducer';
import { FormTwoContext } from './FormTwoContext';
import { UPDATE_FORM_TWO } from './types';


export const FormTwoState = (props) => {

    const initialState = {
        formTwo: {
            ocupation: "",
            economicActivity: "",
            monthlyExpenses: "",
            stratum: "",
            bankAccount: "",
            typeBankAccount: "",
            accountNumber: "",
            creditSituation: "",
            antiguedadMovil: "",
            antiguedadCuentaBancaria: "",
            tieneCuentaBancaria: ""
        }
    }

    const [state, dispatch] = useReducer(FormTwoReducer, initialState);

    const updateFormTwo = (data) => {

        dispatch({
            type: UPDATE_FORM_TWO,
            payload: data
        })
    }

    return (
        <FormTwoContext.Provider value={{ formTwo: state.formTwo, updateFormTwo }}>
            {props.children}
        </FormTwoContext.Provider>
    )

}


